
  import { defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import { CurrencyObject } from '@/store/modules/assets/CurrencyModule';

  export default defineComponent({
    name: 'exchange-rate-editng',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const { can } = useAbility();
      const selectedItem = ref<number>(0);

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('exchangeRateUpdating'), [
          translate('assets'),
        ]);
      });

      const { data } = await store.dispatch(
        Actions.GET_CURRENCY_ID,
        route.params.id
      );

      const currency = ref<CurrencyObject>(data.data);

      const exchangeRateSchema = Yup.object().shape({
        code: Yup.string()
          .required(() => translate('CODE_IS_REQUIRED_FIELD'))
          .label('Code'),
        exchangeRate: Yup.string()
          .required(() => translate('EXCHANGE_RATE_IS_REQUIRED_FIELD'))
          .label('Exchange Rate'),
      });
      const onSubmitCreate = async (values) => {
        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }

        values.exchangeRate = Number(values.exchangeRate);

        await store.dispatch(Actions.UPDATE_CURRENCY, {
          data: values,
          id: currency.value?.id,
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_CREATED_CURRENCY'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'exchange-rate-listing' });
          });
        }
      };

      return {
        onSubmitCreate,
        currency,
        selectedItem,
        submitButton,
        translate,
        exchangeRateSchema,
        goBack,
        can,
      };
    },
  });
